import { useState, useEffect, useRef } from "react";
import "./OnfidoModal.css";
import Cancelimg from "../../assets/img/cancel-01.svg";
import useTranslator from "../../hooks/useTranslator";

/* ─── Country list ───────────────────────────────── */
const COUNTRIES = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahrain",
  "Bangladesh",
  "Belarus",
  "Belgium",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Brazil",
  "Bulgaria",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Chile",
  "China",
  "Colombia",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Ecuador",
  "Egypt",
  "Estonia",
  "Ethiopia",
  "Finland",
  "France",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Guatemala",
  "Honduras",
  "Hungary",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kosovo",
  "Kuwait",
  "Latvia",
  "Lebanon",
  "Libya",
  "Lithuania",
  "Luxembourg",
  "Malaysia",
  "Malta",
  "Mexico",
  "Moldova",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Netherlands",
  "New Zealand",
  "Nigeria",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Panama",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "South Africa",
  "South Korea",
  "Spain",
  "Sri Lanka",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tanzania",
  "Thailand",
  "Tunisia",
  "Turkey",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zimbabwe",
];

const DIAL_CODES = [
  { code: "+1", label: "US +1" },
  { code: "+44", label: "UK +44" },
  { code: "+34", label: "ES +34" },
  { code: "+33", label: "FR +33" },
  { code: "+49", label: "DE +49" },
  { code: "+39", label: "IT +39" },
  { code: "+91", label: "IN +91" },
  { code: "+61", label: "AU +61" },
  { code: "+55", label: "BR +55" },
  { code: "+81", label: "JP +81" },
];

/* ─── Per-country accepted documents ────────────── */
const COUNTRY_DOCUMENTS = {
  // Passport only
  Afghanistan: ["passport"],
  Iran: ["passport"],
  Iraq: ["passport"],
  Syria: ["passport"],
  Yemen: ["passport"],
  Libya: ["passport"],
  Cuba: ["passport"],
  Ethiopia: ["passport"],
  Angola: ["passport"],
  Cambodia: ["passport"],
  Mongolia: ["passport"],
  Zimbabwe: ["passport"],
  Uzbekistan: ["passport"],
  Venezuela: ["passport"],
  Tanzania: ["passport"],

  // Passport + National ID
  Algeria: ["national_id", "passport"],
  Armenia: ["national_id", "passport"],
  Azerbaijan: ["national_id", "passport"],
  Bahrain: ["national_id", "passport"],
  Bangladesh: ["national_id", "passport"],
  Belarus: ["national_id", "passport"],
  Bolivia: ["national_id", "passport"],
  Brazil: ["national_id", "passport"],
  Cameroon: ["national_id", "passport"],
  Chile: ["national_id", "passport"],
  China: ["national_id", "passport"],
  Colombia: ["national_id", "passport"],
  Ecuador: ["national_id", "passport"],
  Egypt: ["national_id", "passport"],
  Ghana: ["national_id", "passport"],
  Guatemala: ["national_id", "passport"],
  Honduras: ["national_id", "passport"],
  India: ["national_id", "passport"],
  Indonesia: ["national_id", "passport"],
  Israel: ["national_id", "passport"],
  Jamaica: ["national_id", "passport"],
  Jordan: ["national_id", "passport"],
  Kazakhstan: ["national_id", "passport"],
  Kenya: ["national_id", "passport"],
  Kosovo: ["national_id", "passport"],
  Kuwait: ["national_id", "passport"],
  Lebanon: ["national_id", "passport"],
  Malaysia: ["national_id", "passport"],
  Mexico: ["national_id", "passport"],
  Moldova: ["national_id", "passport"],
  Montenegro: ["national_id", "passport"],
  Morocco: ["national_id", "passport"],
  Nigeria: ["national_id", "passport"],
  "North Macedonia": ["national_id", "passport"],
  Oman: ["national_id", "passport"],
  Pakistan: ["national_id", "passport"],
  Panama: ["national_id", "passport"],
  Paraguay: ["national_id", "passport"],
  Peru: ["national_id", "passport"],
  Philippines: ["national_id", "passport"],
  Qatar: ["national_id", "passport"],
  Russia: ["national_id", "passport"],
  "Saudi Arabia": ["national_id", "passport"],
  Senegal: ["national_id", "passport"],
  Serbia: ["national_id", "passport"],
  Singapore: ["national_id", "passport"],
  "South Africa": ["national_id", "passport"],
  "South Korea": ["national_id", "passport"],
  "Sri Lanka": ["national_id", "passport"],
  Taiwan: ["national_id", "passport"],
  Thailand: ["national_id", "passport"],
  Tunisia: ["national_id", "passport"],
  Turkey: ["national_id", "passport"],
  Ukraine: ["national_id", "passport"],
  "United Arab Emirates": ["national_id", "passport"],
  Uruguay: ["national_id", "passport"],
  Vietnam: ["national_id", "passport"],
  Argentina: ["national_id", "passport"],

  // EU / Schengen — Passport + National ID + Residence Permit
  Albania: ["national_id", "passport", "residence_permit"],
  Andorra: ["national_id", "passport", "residence_permit"],
  Austria: ["national_id", "passport", "residence_permit"],
  Belgium: ["national_id", "passport", "residence_permit"],
  "Bosnia and Herzegovina": ["national_id", "passport", "residence_permit"],
  Bulgaria: ["national_id", "passport", "residence_permit"],
  Croatia: ["national_id", "passport", "residence_permit"],
  Cyprus: ["national_id", "passport", "residence_permit"],
  "Czech Republic": ["national_id", "passport", "residence_permit"],
  Denmark: ["national_id", "passport", "residence_permit"],
  Estonia: ["national_id", "passport", "residence_permit"],
  Finland: ["national_id", "passport", "residence_permit"],
  France: ["national_id", "passport", "residence_permit"],
  Georgia: ["national_id", "passport", "residence_permit"],
  Germany: ["national_id", "passport", "residence_permit"],
  Greece: ["national_id", "passport", "residence_permit"],
  Hungary: ["national_id", "passport", "residence_permit"],
  Ireland: ["national_id", "passport", "residence_permit"],
  Italy: ["national_id", "passport", "residence_permit"],
  Latvia: ["national_id", "passport", "residence_permit"],
  Lithuania: ["national_id", "passport", "residence_permit"],
  Luxembourg: ["national_id", "passport", "residence_permit"],
  Malta: ["national_id", "passport", "residence_permit"],
  Netherlands: ["national_id", "passport", "residence_permit"],
  Norway: ["national_id", "passport", "residence_permit"],
  Poland: ["national_id", "passport", "residence_permit"],
  Portugal: ["national_id", "passport", "residence_permit"],
  Romania: ["national_id", "passport", "residence_permit"],
  Slovakia: ["national_id", "passport", "residence_permit"],
  Slovenia: ["national_id", "passport", "residence_permit"],
  Spain: ["national_id", "passport", "residence_permit"],
  Sweden: ["national_id", "passport", "residence_permit"],
  Switzerland: ["national_id", "passport", "residence_permit"],

  // English-speaking — Passport + Driving Licence
  Australia: ["passport", "driving_license"],
  Canada: ["passport", "driving_license"],
  "New Zealand": ["passport", "driving_license"],
  "United States": ["passport", "driving_license"],

  // UK — all four
  "United Kingdom": [
    "national_id",
    "passport",
    "driving_license",
    "residence_permit",
  ],

  // Japan — all four
  Japan: ["national_id", "passport", "driving_license", "residence_permit"],
};

/* ─── Icons ──────────────────────────────────────── */
const BackIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
const ChevronRight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
const GlobeIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <ellipse cx="12" cy="12" rx="4" ry="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M4.93 5A17 17 0 0 0 12 7a17 17 0 0 0 7.07-2" />
    <path d="M4.93 19A17 17 0 0 1 12 17a17 17 0 0 1 7.07 2" />
  </svg>
);
const IdCardIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <circle cx="8" cy="12" r="2.5" />
    <line x1="13" y1="10" x2="19" y2="10" />
    <line x1="13" y1="14" x2="17" y2="14" />
  </svg>
);
const ResidenceIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <path d="M8 15v-4l4-3 4 3v4" />
    <line x1="10" y1="15" x2="14" y2="15" />
  </svg>
);
const DrivingIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <circle cx="8" cy="13" r="2" />
    <path d="M13 10h5M13 13h3" />
  </svg>
);
const XSmall = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const ChevronDown = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
const InfoIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    style={{ flexShrink: 0 }}
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);
const LinkIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);
const MessageIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);
const QrIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
    <rect x="14" y="14" width="3" height="3" />
    <rect x="18" y="18" width="3" height="3" />
    <rect x="14" y="18" width="3" height="3" />
    <rect x="18" y="14" width="3" height="3" />
  </svg>
);
const PhoneIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="5" y="2" width="14" height="20" rx="2" />
    <line x1="12" y1="18" x2="12.01" y2="18" />
  </svg>
);
const ExternalLinkIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);
const DesktopIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="3" width="20" height="14" rx="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
  </svg>
);
const PhoneScanIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="7" y="2" width="10" height="20" rx="2" />
    <line x1="11" y1="18" x2="13" y2="18" />
  </svg>
);

/* ─── Document type config ───────────────────────── */
const DOC_CONFIG = {
  passport: {
    titleKey: "passport",
    subtitleKey: "photoPage",
    Icon: GlobeIcon,
    uploadTitleKey: "submitPassportPhotoPage", // goes via guide first
    hasGuide: true,
  },
  national_id: {
    titleKey: "nationalIdentityCard",
    subtitleKey: "frontAndBack",
    Icon: IdCardIcon,
    uploadTitleKey: "submitIdentityCardFront", // straight to upload
    hasGuide: false,
  },
  residence_permit: {
    titleKey: "residencePermit",
    subtitleKey: "frontAndBack",
    Icon: ResidenceIcon,
    uploadTitleKey: "submitResidencePermitFront", // straight to upload
    hasGuide: false,
  },
  driving_license: {
    titleKey: "drivingLicence",
    subtitleKey: "frontAndBack",
    Icon: DrivingIcon,
    uploadTitleKey: "submitDrivingLicenceFront", // straight to upload
    hasGuide: false,
  },
};

/* ─── Passport mock SVG ──────────────────────────── */
const PassportMock = ({ variant }) => {
  const isBlurry = variant === "blurry";
  const isGlare = variant === "glare";
  return (
    <svg
      viewBox="0 0 200 130"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "100%", height: "100%", display: "block" }}
    >
      <defs>
        {isBlurry && (
          <filter id="blur-filter">
            <feGaussianBlur stdDeviation="2.5" />
          </filter>
        )}
        {isGlare && (
          <radialGradient id="glare-grad" cx="60%" cy="30%" r="60%">
            <stop offset="0%" stopColor="white" stopOpacity="0.85" />
            <stop offset="100%" stopColor="white" stopOpacity="0" />
          </radialGradient>
        )}
        <pattern
          id={`lines-${variant}`}
          width="6"
          height="6"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(45)"
        >
          <line
            x1="0"
            y1="0"
            x2="0"
            y2="6"
            stroke="#b8c4d0"
            strokeWidth="0.6"
            opacity="0.5"
          />
        </pattern>
      </defs>
      <rect
        width="200"
        height={variant === "cropped" ? "100" : "130"}
        rx="4"
        fill="#f5f7f9"
      />
      <rect
        width="200"
        height={variant === "cropped" ? "100" : "130"}
        rx="4"
        fill={`url(#lines-${variant})`}
      />
      <rect
        width="200"
        height="18"
        fill="#c8d4e0"
        filter={isBlurry ? "url(#blur-filter)" : ""}
      />
      <text
        x="100"
        y="13"
        textAnchor="middle"
        fontSize="7"
        fill="#2a3a4a"
        fontFamily="monospace"
        fontWeight="bold"
        filter={isBlurry ? "url(#blur-filter)" : ""}
      >
        UNITED KINGDOM OF GREAT BRITAIN
      </text>
      <rect
        x="8"
        y="24"
        width="36"
        height="46"
        rx="2"
        fill={isBlurry ? "#c0c8d0" : "#8fa3b5"}
        filter={isBlurry ? "url(#blur-filter)" : ""}
      />
      {!isBlurry && (
        <>
          <circle cx="26" cy="38" r="9" fill="#d4a880" />
          <rect x="18" y="48" width="16" height="18" rx="2" fill="#4a6080" />
        </>
      )}
      {[
        { y: 26, label: "DOE" },
        { y: 34, label: "JANE SMITH" },
        { y: 42, label: "BRITISH CITIZEN" },
        { y: 50, label: "01 JAN / JAN 95" },
        { y: 58, label: "F    LONDON" },
        { y: 66, label: "01 JAN / JAN 12  IPS" },
      ].map(({ y, label }) => (
        <g key={y} filter={isBlurry ? "url(#blur-filter)" : ""}>
          <text
            x="52"
            y={y + 6}
            fontSize="5.5"
            fill={isBlurry ? "#aaa" : "#1a2a3a"}
            fontFamily="monospace"
          >
            {label}
          </text>
        </g>
      ))}
      {!isBlurry && (
        <path
          d="M52 78 Q80 72 110 76 Q130 80 150 74"
          stroke="#2a3a4a"
          strokeWidth="1"
          fill="none"
          opacity="0.6"
        />
      )}
      {variant !== "cropped" && (
        <>
          <rect
            x="0"
            y="104"
            width="200"
            height="1"
            fill="#b0b8c4"
            opacity="0.5"
          />
          <text
            x="6"
            y="115"
            fontSize="5"
            fill={isBlurry ? "#aaa" : "#1a2a3a"}
            fontFamily="monospace"
            filter={isBlurry ? "url(#blur-filter)" : ""}
          >
            {"P<GBRDOE<<JANE<<SMITH<<<<<<<<<<<<<<<<<"}
          </text>
          <text
            x="6"
            y="126"
            fontSize="5"
            fill={isBlurry ? "#aaa" : "#1a2a3a"}
            fontFamily="monospace"
            filter={isBlurry ? "url(#blur-filter)" : ""}
          >
            {"1234567890GBR8001011F1234086<<<<<<<<<4"}
          </text>
        </>
      )}
      {isGlare && (
        <rect width="200" height="130" rx="4" fill="url(#glare-grad)" />
      )}
    </svg>
  );
};

/* ─── Phone + ID illustration (upload step) ─────── */
const PhoneIdIllustration = () => (
  <svg
    viewBox="0 0 280 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: "100%", height: "100%", display: "block" }}
  >
    <g transform="rotate(-20 140 100)">
      <rect
        x="60"
        y="60"
        width="100"
        height="72"
        rx="8"
        fill="white"
        stroke="#1a1a1a"
        strokeWidth="3"
      />
      <circle
        cx="84"
        cy="88"
        r="14"
        fill="#d0d8e0"
        stroke="#1a1a1a"
        strokeWidth="2.5"
      />
      <circle cx="84" cy="83" r="5" fill="#8a9aaa" />
      <path d="M74 98 Q84 92 94 98" fill="#8a9aaa" />
      <line
        x1="104"
        y1="78"
        x2="150"
        y2="78"
        stroke="#1a1a1a"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <line
        x1="104"
        y1="88"
        x2="148"
        y2="88"
        stroke="#d0d8e0"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <line
        x1="104"
        y1="98"
        x2="145"
        y2="98"
        stroke="#d0d8e0"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </g>
    <rect
      x="148"
      y="44"
      width="68"
      height="112"
      rx="12"
      fill="white"
      stroke="#1a1a1a"
      strokeWidth="3"
    />
    <line
      x1="172"
      y1="55"
      x2="196"
      y2="55"
      stroke="#cccccc"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <circle cx="182" cy="146" r="5" fill="#cccccc" />
  </svg>
);

/* ─── QR code SVG ────────────────────────────────── */
const QrCodeSvg = () => (
  <svg
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: "100%", height: "100%", display: "block" }}
  >
    <rect
      x="10"
      y="10"
      width="60"
      height="60"
      rx="4"
      fill="none"
      stroke="#111"
      strokeWidth="6"
    />
    <rect x="24" y="24" width="32" height="32" rx="2" fill="#111" />
    <rect
      x="130"
      y="10"
      width="60"
      height="60"
      rx="4"
      fill="none"
      stroke="#111"
      strokeWidth="6"
    />
    <rect x="144" y="24" width="32" height="32" rx="2" fill="#111" />
    <rect
      x="10"
      y="130"
      width="60"
      height="60"
      rx="4"
      fill="none"
      stroke="#111"
      strokeWidth="6"
    />
    <rect x="24" y="144" width="32" height="32" rx="2" fill="#111" />
    {[
      [82, 10],
      [90, 10],
      [98, 10],
      [106, 10],
      [114, 10],
      [122, 10],
      [82, 18],
      [98, 18],
      [114, 18],
      [82, 26],
      [90, 26],
      [106, 26],
      [122, 26],
      [82, 34],
      [98, 34],
      [106, 34],
      [114, 34],
      [82, 42],
      [90, 42],
      [98, 42],
      [114, 42],
      [122, 42],
      [82, 50],
      [106, 50],
      [114, 50],
      [82, 58],
      [90, 58],
      [98, 58],
      [106, 58],
      [122, 58],
      [10, 82],
      [26, 82],
      [42, 82],
      [58, 82],
      [74, 82],
      [82, 82],
      [98, 82],
      [114, 82],
      [130, 82],
      [154, 82],
      [170, 82],
      [186, 82],
      [10, 90],
      [34, 90],
      [58, 90],
      [82, 90],
      [106, 90],
      [130, 90],
      [162, 90],
      [178, 90],
      [10, 98],
      [18, 98],
      [42, 98],
      [66, 98],
      [74, 98],
      [98, 98],
      [106, 98],
      [122, 98],
      [138, 98],
      [154, 98],
      [170, 98],
      [10, 106],
      [26, 106],
      [50, 106],
      [58, 106],
      [82, 106],
      [98, 106],
      [114, 106],
      [130, 106],
      [146, 106],
      [178, 106],
      [186, 106],
      [10, 114],
      [34, 114],
      [42, 114],
      [66, 114],
      [74, 114],
      [90, 114],
      [114, 114],
      [138, 114],
      [162, 114],
      [178, 114],
      [10, 122],
      [18, 122],
      [26, 122],
      [50, 122],
      [82, 122],
      [98, 122],
      [106, 122],
      [130, 122],
      [146, 122],
      [154, 122],
      [170, 122],
      [186, 122],
      [130, 130],
      [146, 130],
      [162, 130],
      [178, 130],
      [186, 130],
      [130, 138],
      [146, 138],
      [170, 138],
      [130, 146],
      [138, 146],
      [154, 146],
      [178, 146],
      [186, 146],
      [130, 154],
      [162, 154],
      [170, 154],
      [130, 162],
      [138, 162],
      [154, 162],
      [162, 162],
      [178, 162],
      [186, 162],
      [130, 170],
      [146, 170],
      [154, 170],
      [162, 170],
      [130, 178],
      [138, 178],
      [146, 178],
      [162, 178],
      [170, 178],
      [186, 178],
    ].map(([x, y], i) => (
      <rect key={i} x={x} y={y} width="8" height="8" fill="#111" />
    ))}
  </svg>
);

/* ─── Shared branding ────────────────────────────── */
const OnfidoBranding = () => (
  <div className="onfido-branding">
    <img
      src="/images/onfido-logo.svg"
      alt="Onfido logo"
      className="onfido-logo"
    />
  </div>
);

/* ─── Shared top bar ─────────────────────────────── */
const TopBar = ({ onBack, onClose, _t }) => (
  <div className="onfido-topbar">
    {onBack ? (
      <button
        className="onfido-back-btn"
        onClick={onBack}
        aria-label={_t("back")}
      >
        <BackIcon />
      </button>
    ) : (
      <div className="onfido-topbar-spacer" />
    )}
    <div className="cursor-pointer onfido-close-wrap" onClick={onClose}>
      <img
        src={Cancelimg}
        alt={_t("close")}
        className="canceicon topRightIcon"
      />
    </div>
  </div>
);

/* ═══════════════════════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════════════════════ */
export default function OnfidoModal({ onClose, onUploadComplete }) {
  const STEPS = {
    INTRO: "intro",
    CHOOSE_DOC: "choose-doc",
    PASSPORT_GUIDE: "passport-guide",
    UPLOAD_PHOTO: "upload-photo",
    CHECK_IMAGE: "check-image",
    CONTINUE_PHONE: "continue-phone",
    SECURE_LINK_QR: "secure-link-qr",
    SECURE_LINK_SMS: "secure-link-sms",
  };

  const [step, setStep] = useState(STEPS.INTRO);
  const [loading, setLoading] = useState(true);

  /* choose-doc */
  const [selectedCountry, setSelectedCountry] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);
  const { _t } = useTranslator();

  /* selected document type (for guide/upload steps) */
  const [selectedDocType, setSelectedDocType] = useState("passport");

  /* check-image — simulated preview */
  const [uploadedFileName, setUploadedFileName] =
    useState("passport_photo.jpg");
  const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
  const [uploadedFileType, setUploadedFileType] = useState(null);
  const fileInputRef = useRef(null);

  /* secure-link-qr — expand how-to */
  const [qrHowToOpen, setQrHowToOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  /* secure-link-sms */
  const [dialCode, setDialCode] = useState("+34");
  const [dialOpen, setDialOpen] = useState(false);
  const [phone, setPhone] = useState("");
  const dialRef = useRef(null);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2500);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const h = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
        setSearch("");
      }
      if (dialRef.current && !dialRef.current.contains(e.target))
        setDialOpen(false);
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const filteredCountries = COUNTRIES.filter((c) =>
    c.toLowerCase().includes(search.toLowerCase())
  );

  /* Resolve accepted docs for the selected country */
  const acceptedDocs = selectedCountry
    ? (COUNTRY_DOCUMENTS[selectedCountry] ?? ["passport"])
    : [];

  const overlayClass =
    "onfido-overlay pm-wrapper popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen";

  const handleCopyLink = () => {
    navigator.clipboard?.writeText("https://id.onfido.com/verify/link/abc123");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  /* Navigate to guide (passport) or straight to upload (all others) */
  const handleDocSelect = (docType) => {
    setSelectedDocType(docType);
    const cfg = DOC_CONFIG[docType];
    setStep(cfg?.hasGuide ? STEPS.PASSPORT_GUIDE : STEPS.UPLOAD_PHOTO);
  };

  /* ════════ INTRO ════════ */
  if (step === STEPS.INTRO)
    return (
      <div className={overlayClass}>
        <div className="onfido-card">
          <TopBar onClose={onClose} _t={_t} />
          {loading ? (
            <div className="onfido-loader-wrap">
              <div className="onfido-spinner-ring" />
            </div>
          ) : (
            <div
              className="onfido-content"
              style={{ animation: "onfido-fade-in 0.3s ease" }}
            >
              <div className="onfido-banner">
                <img
                  src="/images/onfido-banner.svg"
                  alt={_t("verificationIllustration")}
                />
              </div>
              <div className="onfido-text-block">
                <h2 className="onfido-heading">{_t("verifyIdentity")}</h2>
                <p className="onfido-sub">{_t("verifySubtitle")}</p>
              </div>
              <button
                className="onfido-start-btn"
                onClick={() => setStep(STEPS.CHOOSE_DOC)}
              >
                {_t("startVerification")}
              </button>
              <OnfidoBranding />
            </div>
          )}
        </div>
      </div>
    );

  /* ════════ CHOOSE DOC ════════ */
  if (step === STEPS.CHOOSE_DOC)
    return (
      <div className={overlayClass}>
        <div className="onfido-card">
          <TopBar onClose={onClose} _t={_t} />
          <div className="onfido-content onfido-fade-in">
            <div className="onfido-text-block" style={{ marginBottom: "2vw" }}>
              <h2 className="onfido-heading">{_t("chooseDocument")}</h2>
              <p className="onfido-sub">{_t("chooseDocumentSub")}</p>
            </div>

            {/* ── Country dropdown ── */}
            <div className="odoc-field-group" ref={dropdownRef}>
              <label className="odoc-label">{_t("issuingCountry")}</label>
              {selectedCountry && !dropdownOpen ? (
                <div
                  className="odoc-selected-pill"
                  onClick={() => {
                    setDropdownOpen(true);
                    setSearch("");
                  }}
                >
                  <span className="odoc-selected-text">{selectedCountry}</span>
                  <button
                    className="odoc-clear-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedCountry("");
                      setDropdownOpen(false);
                    }}
                    aria-label={_t("clearCountry")}
                  >
                    <XSmall />
                  </button>
                </div>
              ) : (
                <div className="odoc-dropdown-wrap">
                  <div
                    className={`odoc-input-row${dropdownOpen ? " open" : ""}`}
                    onClick={() => setDropdownOpen(true)}
                  >
                    <input
                      className="odoc-search-input"
                      placeholder={_t("searchCountry")}
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                        setDropdownOpen(true);
                      }}
                      autoFocus={dropdownOpen}
                    />
                    <span
                      className={`odoc-chevron${dropdownOpen ? " open" : ""}`}
                    >
                      <ChevronDown />
                    </span>
                  </div>
                  {dropdownOpen && (
                    <ul className="odoc-dropdown-list">
                      {filteredCountries.length === 0 ? (
                        <li className="odoc-dropdown-empty">
                          {_t("noResults")}
                        </li>
                      ) : (
                        filteredCountries.map((c) => (
                          <li
                            key={c}
                            className={`odoc-dropdown-item${c === selectedCountry ? " active" : ""}`}
                            onClick={() => {
                              setSelectedCountry(c);
                              setDropdownOpen(false);
                              setSearch("");
                            }}
                          >
                            {c}
                          </li>
                        ))
                      )}
                    </ul>
                  )}
                </div>
              )}
            </div>

            {/* ── Accepted documents list (dynamic per country) ── */}
            {selectedCountry && !dropdownOpen && (
              <div className="odoc-accepted-wrap">
                <label className="odoc-label">{_t("acceptedDocuments")}</label>
                {acceptedDocs.map((docType) => {
                  const cfg = DOC_CONFIG[docType];
                  const Icon = cfg.Icon;
                  return (
                    <button
                      key={docType}
                      className="odoc-passport-card"
                      style={{ marginBottom: "0.694vw" }}
                      onClick={() => handleDocSelect(docType)}
                    >
                      <div className="odoc-passport-left">
                        <span className="odoc-passport-icon">
                          <Icon />
                        </span>
                        <div className="odoc-passport-text">
                          <span className="odoc-passport-title">
                            {_t(cfg.titleKey)}
                          </span>
                          <span className="odoc-passport-sub">
                            {_t(cfg.subtitleKey)}
                          </span>
                        </div>
                      </div>
                      <span className="odoc-passport-chevron">
                        <ChevronRight />
                      </span>
                    </button>
                  );
                })}
              </div>
            )}

            <div style={{ flex: 1 }} />
            <OnfidoBranding />
          </div>
        </div>
      </div>
    );

  /* ════════ PASSPORT / DOCUMENT GUIDE ════════ */
  if (step === STEPS.PASSPORT_GUIDE)
    return (
      <div className={overlayClass}>
        <div className="onfido-card onfido-card-scroll">
          <TopBar
            onBack={() => setStep(STEPS.CHOOSE_DOC)}
            onClose={onClose}
            _t={_t}
          />
          <div className="onfido-content onfido-passport-content onfido-fade-in">
            <div className="onfido-passport-content-inner">
              <div
                className="onfido-text-block"
                style={{ marginBottom: "1.3889vw" }}
              >
                <h2 className="onfido-heading">
                  {_t("submitPassportPhotoPage")}
                </h2>
                <p className="onfido-sub">{_t("scansNotAccepted")}</p>
              </div>
              <div className="opass-grid">
                {[
                  {
                    variant: "cropped",
                    badge: "bad",
                    labelKey: "passportGuideCropped",
                  },
                  {
                    variant: "blurry",
                    badge: "bad",
                    labelKey: "passportGuideBlurry",
                  },
                  {
                    variant: "glare",
                    badge: "bad",
                    labelKey: "passportGuideGlare",
                  },
                  {
                    variant: "good",
                    badge: "good",
                    labelKey: "passportGuideGood",
                  },
                ].map(({ variant, badge, labelKey }) => (
                  <div key={variant} className="opass-item">
                    <div className={`opass-img-wrap opass-img-wrap--${badge}`}>
                      <PassportMock variant={variant} />
                      <span className={`opass-badge opass-badge--${badge}`}>
                        {badge === "bad" ? (
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="white"
                            stroke="white"
                            strokeWidth="3"
                          >
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                          </svg>
                        ) : (
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="white"
                            strokeWidth="3"
                          >
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        )}
                      </span>
                    </div>
                    <p className="opass-label">{_t(labelKey)}</p>
                  </div>
                ))}
              </div>
            </div>
            <button
              className="onfido-start-btn"
              style={{ marginTop: "1.6667vw" }}
              onClick={() => setStep(STEPS.UPLOAD_PHOTO)}
            >
              {_t("continue")}
            </button>
            <OnfidoBranding />
          </div>
        </div>
      </div>
    );

  /* ════════ UPLOAD PHOTO ════════ */
  if (step === STEPS.UPLOAD_PHOTO) {
    const uploadCfg = DOC_CONFIG[selectedDocType] ?? DOC_CONFIG.passport;
    const backStep = uploadCfg.hasGuide
      ? STEPS.PASSPORT_GUIDE
      : STEPS.CHOOSE_DOC;
    return (
      <div className={overlayClass}>
        <div className="onfido-card">
          <TopBar onBack={() => setStep(backStep)} onClose={onClose} _t={_t} />
          <div className="onfido-content onfido-fade-in">
            <div className="onfido-banner onfido-banner-sm">
              <PhoneIdIllustration />
            </div>
            <div className="onfido-text-block">
              <h2 className="onfido-heading">{_t(uploadCfg.uploadTitleKey)}</h2>
              <p className="onfido-sub">{_t("takePhotoWithPhone")}</p>
            </div>

            <div className="oup-info-note">
              <InfoIcon />
              <span>{_t("scansOrPhotocopiesNotAccepted")}</span>
            </div>

            <div style={{ flex: 1 }} />

            <input
              ref={fileInputRef}
              type="file"
              accept="image/*,application/pdf"
              style={{ display: "none" }}
              onChange={(e) => {
                const file = e.target.files[0];
                if (!file) return;
                if (uploadedFileUrl) URL.revokeObjectURL(uploadedFileUrl);
                const url = URL.createObjectURL(file);
                const type = file.type.startsWith("image/") ? "image" : "pdf";
                setUploadedFileName(file.name);
                setUploadedFileUrl(url);
                setUploadedFileType(type);
                setStep(STEPS.CHECK_IMAGE);
              }}
            />

            <button
              className="onfido-outline-btn"
              onClick={() => fileInputRef.current?.click()}
            >
              {_t("uploadPhoto")}
            </button>
            <button
              className="onfido-start-btn"
              onClick={() => setStep(STEPS.CONTINUE_PHONE)}
            >
              {_t("continueOnPhone")}
            </button>
            <OnfidoBranding />
          </div>
        </div>
      </div>
    );
  }

  /* ════════ CHECK IMAGE ════════ */
  if (step === STEPS.CHECK_IMAGE)
    return (
      <div className={overlayClass}>
        <div className="onfido-card">
          <TopBar
            onBack={() => setStep(STEPS.UPLOAD_PHOTO)}
            onClose={onClose}
            _t={_t}
          />
          <div className="onfido-content onfido-fade-in">
            <div
              className="onfido-text-block"
              style={{ marginBottom: "1.3889vw" }}
            >
              <h2 className="onfido-heading">{_t("checkYourImage")}</h2>
              {uploadedFileName && (
                <p
                  className="onfido-sub"
                  style={{
                    fontSize: "var(--text-12)",
                    color: "var(--text-muted)",
                    marginTop: "0.2778vw",
                  }}
                >
                  {uploadedFileName}
                </p>
              )}
            </div>

            <div className="ochk-preview-wrap">
              {uploadedFileType === "image" && uploadedFileUrl ? (
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "var(--canvas)",
                    padding: "0.8333vw",
                    minHeight: "18vw",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={uploadedFileUrl}
                    alt={_t("uploadedDocument")}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "28vw",
                      objectFit: "contain",
                      borderRadius: "var(--radius-sm)",
                      boxShadow: "var(--shadow-dropdown)",
                      display: "block",
                    }}
                  />
                </div>
              ) : uploadedFileType === "pdf" && uploadedFileUrl ? (
                <iframe
                  src={uploadedFileUrl}
                  title={_t("uploadedPdf")}
                  style={{
                    flex: 1,
                    width: "100%",
                    minHeight: "28vw",
                    border: "none",
                    background: "var(--surface)",
                    display: "block",
                  }}
                />
              ) : (
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "var(--canvas)",
                    minHeight: "18vw",
                    color: "var(--text-muted)",
                    fontSize: "var(--text-14)",
                  }}
                >
                  {_t("noPreviewAvailable")}
                </div>
              )}
            </div>

            <button
              className="onfido-outline-btn"
              style={{ marginTop: "1.3889vw" }}
              onClick={() => {
                if (uploadedFileUrl) URL.revokeObjectURL(uploadedFileUrl);
                setUploadedFileUrl(null);
                setUploadedFileType(null);
                setStep(STEPS.UPLOAD_PHOTO);
                if (fileInputRef.current) fileInputRef.current.value = "";
              }}
            >
              {_t("redo")}
            </button>
            <button
              className="onfido-start-btn"
              onClick={() => onUploadComplete && onUploadComplete()}
            >
              {_t("upload")}
            </button>
            <OnfidoBranding />
          </div>
        </div>
      </div>
    );

  /* ════════ CONTINUE ON PHONE ════════ */
  if (step === STEPS.CONTINUE_PHONE)
    return (
      <div className={overlayClass}>
        <div className="onfido-card">
          <TopBar
            onBack={() => setStep(STEPS.UPLOAD_PHOTO)}
            onClose={onClose}
            _t={_t}
          />
          <div className="onfido-content onfido-fade-in">
            <div className="onfido-text-block">
              <h2 className="onfido-heading">{_t("continueOnYourPhone")}</h2>
              <p className="onfido-sub">{_t("hereHowToDoIt")}</p>
            </div>

            <div className="ocph-steps">
              {[
                { icon: <ExternalLinkIcon />, labelKey: "sendSecureLinkStep" },
                {
                  icon: <PhoneScanIcon />,
                  labelKey: "openLinkCompleteTasksStep",
                },
                { icon: <DesktopIcon />, labelKey: "checkBackToFinishStep" },
              ].map(({ icon, labelKey }, i) => (
                <div key={i} className="ocph-step-item">
                  <span className="ocph-step-icon">{icon}</span>
                  <span className="ocph-step-text">{_t(labelKey)}</span>
                </div>
              ))}
            </div>

            <div style={{ flex: 1 }} />
            <button
              className="onfido-start-btn"
              onClick={() => setStep(STEPS.SECURE_LINK_QR)}
            >
              {_t("getSecureLink")}
            </button>
            <OnfidoBranding />
          </div>
        </div>
      </div>
    );

  /* ════════ SECURE LINK — QR ════════ */
  if (step === STEPS.SECURE_LINK_QR)
    return (
      <div className={overlayClass}>
        <div className="onfido-card onfido-card-scroll">
          <TopBar
            onBack={() => setStep(STEPS.CONTINUE_PHONE)}
            onClose={onClose}
            _t={_t}
          />
          <div className="onfido-content onfido-fade-in">
            <div className="onfido-text-block" style={{ marginBottom: "1vw" }}>
              <h2 className="onfido-heading">{_t("getYourSecureLink")}</h2>
              <p className="onfido-sub">{_t("scanQrCodeSub")}</p>
            </div>

            <div className="oqr-code-wrap">
              <QrCodeSvg />
            </div>

            <button
              className={`oqr-how-btn${qrHowToOpen ? " open" : ""}`}
              onClick={() => setQrHowToOpen(!qrHowToOpen)}
            >
              <InfoIcon />
              <span>{_t("howToScanQrCode")}</span>
            </button>
            {qrHowToOpen && (
              <ul className="oqr-how-list">
                <li>{_t("pointCameraAtQr")}</li>
                <li>{_t("downloadQrScanner")}</li>
              </ul>
            )}

            <p className="oqr-alt-label">{_t("orChooseAlternativeMethod")}</p>

            <div className="oqr-alt-list">
              <button className="oqr-alt-item" onClick={handleCopyLink}>
                <span className="oqr-alt-icon">
                  <LinkIcon />
                </span>
                <span className="oqr-alt-text">
                  {copied ? _t("copied") : _t("copyLink")}
                </span>
                <span className="oqr-alt-chevron">
                  <ChevronRight />
                </span>
              </button>
              <button
                className="oqr-alt-item"
                onClick={() => setStep(STEPS.SECURE_LINK_SMS)}
              >
                <span className="oqr-alt-icon">
                  <MessageIcon />
                </span>
                <span className="oqr-alt-text">{_t("getLinkViaSms")}</span>
                <span className="oqr-alt-chevron">
                  <ChevronRight />
                </span>
              </button>
            </div>

            <OnfidoBranding />
          </div>
        </div>
      </div>
    );

  /* ════════ SECURE LINK — SMS ════════ */
  return (
    <div className={overlayClass}>
      <div className="onfido-card">
        <TopBar
          onBack={() => setStep(STEPS.SECURE_LINK_QR)}
          onClose={onClose}
          _t={_t}
        />
        <div className="onfido-content onfido-fade-in">
          <div className="onfido-text-block">
            <h2 className="onfido-heading">{_t("getYourSecureLink")}</h2>
            <p className="onfido-sub">{_t("sendOneTimeLink")}</p>
          </div>

          <label
            className="odoc-label"
            style={{ marginBottom: "0.5vw", display: "block" }}
          >
            {_t("enterMobileNumber")}
          </label>
          <div className="osms-phone-row">
            <div className="osms-dial-wrap" ref={dialRef}>
              <button
                className="osms-dial-btn"
                onClick={() => setDialOpen(!dialOpen)}
              >
                <PhoneIcon />
                <span>{dialCode}</span>
                <ChevronDown />
              </button>
              {dialOpen && (
                <ul className="osms-dial-list">
                  {DIAL_CODES.map((d) => (
                    <li
                      key={d.code}
                      className={`osms-dial-item${d.code === dialCode ? " active" : ""}`}
                      onClick={() => {
                        setDialCode(d.code);
                        setDialOpen(false);
                      }}
                    >
                      {d.label}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <input
              className="osms-phone-input"
              type="tel"
              placeholder=""
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          <button
            className="onfido-start-btn"
            style={{ marginTop: "1.3889vw" }}
          >
            {_t("sendLink")}
          </button>

          <p className="oqr-alt-label">{_t("orChooseAlternativeMethod")}</p>

          <div className="oqr-alt-list">
            <button className="oqr-alt-item" onClick={handleCopyLink}>
              <span className="oqr-alt-icon">
                <LinkIcon />
              </span>
              <span className="oqr-alt-text">
                {copied ? _t("copied") : _t("copyLink")}
              </span>
              <span className="oqr-alt-chevron">
                <ChevronRight />
              </span>
            </button>
            <button
              className="oqr-alt-item"
              onClick={() => setStep(STEPS.SECURE_LINK_QR)}
            >
              <span className="oqr-alt-icon">
                <QrIcon />
              </span>
              <span className="oqr-alt-text">{_t("scanQrCode")}</span>
              <span className="oqr-alt-chevron">
                <ChevronRight />
              </span>
            </button>
          </div>

          <OnfidoBranding />
        </div>
      </div>
    </div>
  );
}
